import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import {
  Autocomplete,
  Button,
  Checkbox,
  TextField,
  Typography
} from "@mui/material";
import { Icon } from "@progress/kendo-react-common";
import axios from "axios";
import { useAuth } from "oidc-react";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { filterAllowedColumn, ShowError, ShowSucess } from "../_helper/helper";
import AdvanceSearch from "../CommonComponents/AdvanceSearch";
import TelerikDataTable from "../CommonComponents/TelerikDataTable";
import visileColumns from "./visibleColumns";
import { loadingPanel } from "../CommonComponents/CommonFunction";


const icon = <CheckBoxOutlineBlank fontSize="small" />;
const checkedIcon = <CheckBox fontSize="small" />;


const JobNotification = () => {
  let {
    columns,
    loadingSearch,
    searchParameter,
    ColumnsSorted,
    searchResults: { results, rowCount },
  } = useSelector((state) => state.advanceSearchv2Reducer);
  const userData = useAuth();
  const [notificationText, setNotificationText] = useState("");
  const [notifiactionStatus, setNotificationStatus] = useState("Notification");
  const [expandedSearchResult, setexpandedSearchResult] = useState(false);
  const [sortedColumns, setSortedColumns] = useState([]);
  const [searchParams, setSearchParams] = useState([]);
  const [page, setPage] = useState(1);
  const [additionalWhere, setAdditionalWhere] = useState("");
  const [sortData, setSortData] = useState([
    { field: "CreatedDate", dir: "desc" },
  ]);
  const [pageSize, setPageSize] = useState(10);
  const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");
  const [DeparementCode, setDepartmentCode] = useState(
    userData?.profile?.DEPT_CODE ? userData.profile.DEPT_CODE[0] : ""
  );
  const listName = "Job_Notifications";
  const [announcementList, setAnnouncementList] = useState([]);
  const [selectAnnouncement, setSelectAnnouncement] = useState(null);
  const [applicantList, setApplicantList] = useState([]);
  const [selectApplicant, setSelectApplicant] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState({})


  const SendNotificatiob = (isBroadcast = false) => {

    if (!selectAnnouncement && !selectAnnouncement?.value) {
      setError((state) => { return { ...state, jobannouncement: true } })
    }

    if (!isBroadcast && !(selectApplicant && selectApplicant.length)) {
      setError((state) => { return { ...state, jobapplicant: true } })
    }

    if (!notificationText?.trim()) {
      setError((state) => { return { ...state, notificationText: true } })
    }

    if ((!selectAnnouncement && !selectAnnouncement?.value)
      || (!isBroadcast && !(selectApplicant && selectApplicant.length))
      || (!notificationText?.trim())) {
      return false
    }
    getWhere();
    setIsLoading(true)
    const payload = {
      notificationText: notificationText,
      remark: "Job Application",
      status: notifiactionStatus,
      application: "Job Application",
      announcementId: selectAnnouncement?.value,
      isBroadcast: isBroadcast,
      employeeIds: isBroadcast ? [] : selectApplicant?.map((i) => {
        return i.value
      }),
    };

    axios
      .post(
        `${process.env.REACT_APP_API_DOTNET_URL}/Notification/Send-multiple-notifications`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          },
        }
      )
      .then((response) => {
        setSortData([{ field: "CreatedDate", dir: "desc " }]);
        ShowSucess("Successfully Created.");
        setNotificationText("");
        setSelectAnnouncement(null)
        setSelectApplicant([])

        // setNotificationStatus("");
      })
      .catch((error) => {
        ShowError("Internal Server Error !");
      })
      .finally(() => {
        setIsLoading(false)
      })
  };

  useEffect(() => {
    if (DeparementCode) {
      setAdditionalWhere(`Department = '${DeparementCode}'`);
    }
  }, [DeparementCode]);

  const getJobApplication = () => {
    setIsLoading(true)
    axios
      .post(
        `${process.env.REACT_APP_API_DOTNET_URL}/JobApplicantAdvanceSearch/JobApplicant-global`,
        {
          additionalWhere: "totalApplication > 0",
          tableName: "vw_Job_Applications_of_Announcement",
          searchParams: "[]",
          // searchParams: JSON.stringify([]),
          columns: "ANNOUNCEMENT_ID,totalApplication",
          pageNumber: 1,
          pageSize: 1000000,
          sortData: "",
          qID: 0,
          location: "JobApplicant-global",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem(
              "jwt_access_token"
            )}`,
          },
        }
      )
      .then((res) => {
        const finalData = res.data.results;
        const optionFinal = finalData?.map((i) => {
          return {
            label: i.ANNOUNCEMENT_ID?.trim() + " - " + `(${i.totalApplication})`,
            value: i.ANNOUNCEMENT_ID?.trim(),

          };
        });
        setAnnouncementList(optionFinal);
      })
      .catch((err) => { }).finally(() => {
        setIsLoading(false)
      })
  };

  const getJobApplicant = (announcementId) => {
    setIsLoading(true)
    axios
      .post(
        `${process.env.REACT_APP_API_DOTNET_URL}/JobApplicantAdvanceSearch/JobApplicant-global`,
        {
          additionalWhere: `AnnouncementId = '${announcementId}'`,
          tableName: "Applicant_List",
          searchParams: "[]",
          // searchParams: JSON.stringify([]),
          columns: "EmpId,FirstName ,LastName ,MiddleName,AnnouncementId",
          pageNumber: 1,
          pageSize: 1000000,
          sortData: "",
          qID: 0,
          location: "JobApplicant-global",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${sessionStorage.getItem(
              "jwt_access_token"
            )}`,
          },
        }
      )
      .then((res) => {
        const finalData = res.data.results;
        let optionFinal = finalData?.map((i) => {
          return {
            label: `${i.EmpId} ${(i?.FirstName?.trim() || i?.LastName?.trim() || i?.MiddleName?.trim()) ? '-' : ''} ${i?.FirstName?.trim() || ''} ${i?.MiddleName?.trim() || ''} ${i?.LastName?.trim() || ''}`,
            value: i.EmpId,
          };
        });
        setSelectApplicant(optionFinal)
        setApplicantList(optionFinal);
      })
      .catch((err) => { }).finally(() => {
        setIsLoading(false)
      })
  };

  useEffect(() => {
    getJobApplication();
    // getJobApplicant()
  }, []);

  useEffect(() => {
    if (loadingSearch) setexpandedSearchResult(true);
  }, [loadingSearch]);

  useEffect(() => {
    if (ColumnsSorted[listName] !== undefined) {
      setSortedColumns(ColumnsSorted[listName]);
    } else {
      if (columns && visileColumns.length > 0 && columns.length > 0) {
        const clms = visileColumns.map((d) => d.field.toLowerCase());
        const data = columns
          .filter((p) => clms.indexOf(p.column_name.toLowerCase()) < 0)
          .map((p) => {
            return {
              field: p.column_name,
              show: false,
              locked: false,
              width: 200,
              title: p.column_title,
              filter: "text",
            };
          });
        setSortedColumns(
          filterAllowedColumn(userData, visileColumns.concat(data)),
          "employeeID"
        );
      }
    }
  }, [columns]);

  const handlePageChange = (event) => {
    setPage(event.page.skip / event.page.take + 1);
    setPageSize(event.page.take);
  };
  const handleSortChange = (sort) => {
    setSortData(sort);
    setPage(1);
  };
  const handleFilterChange = (data) => {
    setAdditionalWhere(data);
    setPage(1);
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setPage(1);
  };
  const getWhere = () => {
    // if (userData.profile.role === "user") {
    //   return `employeeID = ${userData?.profile?.EmployeeID}  ${additionalWhere ? `and ${additionalWhere}` : ``
    //     }`;
    // } else {
    return additionalWhere;
    // }
  };

  useEffect(() => {
    if (error && Object.keys(error).length) {
      if (selectAnnouncement && selectAnnouncement?.value) {
        setError((state) => { return { ...state, jobannouncement: false } })
      }
    }
  }, [selectAnnouncement])

  useEffect(() => {
    if (error && Object.keys(error).length) {
      if (selectApplicant && selectApplicant?.length) {
        setError((state) => { return { ...state, jobapplicant: false } })
      }
    }
  }, [selectApplicant])

  useEffect(() => {
    if (error && Object.keys(error).length) {
      if (notificationText?.trim()) {
        setError((state) => { return { ...state, notificationText: false } })
      }
    }
  }, [notificationText])


  return (
    <Fragment>
      <Container fluid={true}>
        {isLoading && loadingPanel()}
        <Row className="bg-primary rounded m-0 p-0 py-3 mb-3 ">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h5">
              {/* <div> */}
              {/* <Icon style={{ fontSize: '25px', margin:"10px"}} name="file-ascx" /> */}
              <Icon style={{ fontSize: "25px", margin: "10px" }} name="graph" />
              Job Notifications
              {/* </div> */}
            </Typography>
          </div>
        </Row>
        <Card style={{ marginTop: "10px", padding: "10px" }}>
          <Row className="mb-2">
            <Col md="3">
              <Autocomplete
                size="small"
                value={selectAnnouncement}
                id="tags-outlined"
                name="jobannouncement"
                options={announcementList?.length ? announcementList : []}
                onChange={(e, value) => {
                  setSelectAnnouncement(value);
                  getJobApplicant(value?.value)
                }}
                getOptionLabel={(option) => option.label}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    label="Select Job Announcement"
                    placeholder="Job Announcement - Total Applications"
                    InputLabelProps={{ shrink: true }}
                    error={error && error?.jobannouncement}

                  />
                )}
              />
              {/* <FormControl size="small" fullWidth >
                <InputLabel  >
                  Select Job Announcement
                </InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={selectAnnouncement}
                  label="Notification Status"
                  onChange={(e) => {
                    setSelectAnnouncement(e.target.value);
                  }}
                >
                  {announcementList?.map((i) => {
                    return <MenuItem value={i.value}>{i.label}</MenuItem>;
                  })}
                </Select>
              </FormControl> */}
            </Col>
          </Row>
          <Row>
            <Col md="4">
              <Autocomplete
                multiple
                size="small"
                onChange={(event, value) => {
                  setSelectApplicant(value)
                }}
                limitTags={2}
                value={selectApplicant}
                id="checkboxes-tags-demo"
                options={applicantList}
                disableCloseOnSelect
                getOptionLabel={(option) => option.label}
                renderOption={(props, option, { selected }) => {
                  const { key, ...optionProps } = props;
                  return (
                    <li key={key} {...optionProps}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.label}
                    </li>
                  );
                }}
                // style={{ width: 500 }}
                renderInput={(params) => (
                  <TextField {...params} label="Select Applicant"
                    placeholder="Select Applicant"
                    required
                    InputLabelProps={{ shrink: true }}
                    error={error && error?.jobapplicant}

                  />
                )}
              />
              {/* <Autocomplete
                multiple
                size="small"
                // value={selectAnnouncement} 
                id="tags-outlined"
                options={applicantList?.length ? applicantList : []}
                onChange={(e, value) => {
                  console.log("sdfjkshfkhds", value)
                  setSelectApplicant(value)
                }}
                getOptionLabel={(option) => option.label}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Applicant"
                    placeholder="Favorites"
                  />
                )}
              /> */}
            </Col>

          </Row>
          <Row className="mb-3">
            <Col className="mb-3">
              <TextField
                required
                fullWidth
                size="small"
                autoComplete="off"
                inputProps={{
                  maxLength: 200,
                }}
                margin="dense"
                variant="outlined"
                label={"Notification Text"}
                multiline
                rows={3}
                value={notificationText}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => {
                  setNotificationText(e.target.value);
                }}

                error={error && error?.notificationText}
              />
            </Col>
          </Row>
          <Col>
            <Button
              variant="contained"
              className="bg-primary mx-2"
              onClick={() => SendNotificatiob(false)}
            >
              Send To Selected Applicant
            </Button>
            <Button
              variant="contained"
              className="bg-primary mx-2"
              onClick={() => SendNotificatiob(true)}
            >
              Send Broadcast
            </Button>
          </Col>
        </Card>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <AdvanceSearch
                  id={listName}
                  gridId={listName}
                  location="JobApplicant-global"
                  columnList={"*"}
                  columnRefernces={[]}
                  tableName={"job_notification"}
                  searchParams={searchParams}
                  additionalWhere={getWhere()}
                  expanded={true}
                  sortData={sortData}
                  pageNumber={page}
                  pageSize={pageSize}
                  chooseFilterMethod={chooseFilterMethod}
                  applicationName={"JobApplication"}
                />

                <div>
                  {sortedColumns.length > 0 && (
                    <TelerikDataTable
                      id={listName}
                      pageSize={pageSize}
                      totalCount={rowCount}
                      skip={(page - 1) * pageSize}
                      take={pageSize}
                      data={results || []}
                      sortData={sortData}
                      onFilterChange={handleFilterChange}
                      onSortChange={handleSortChange}
                      onPageChange={handlePageChange}
                      onPageSizeChange={handlePageSizeChange}
                      selectedColumns={sortedColumns}
                      setSortedColumns={setSortedColumns}
                      loading={loadingSearch}
                      // actions={actions}
                      isDashboard={true}
                      setChooseFilterMethod={setChooseFilterMethod}
                      chooseFilterMethod={chooseFilterMethod}
                    ></TelerikDataTable>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default JobNotification;
